import css from '@styled-system/css';

const sizes = {
  medium: '42px',
  large: '52px',
};

const circledVariant = ({ circled, size }) =>
  circled &&
  css({
    borderRadius: 5,
    p: 0,
    width: sizes[size],
    height: sizes[size],
    minWidth: 'auto',
  });

export default circledVariant;
